import { staticContentAxios as axios } from './configuration/axiosConfig';
import { ClientResponse } from '../model/types/ClientResponse';
import { DataResponseWithHistoriaFlag } from '../model/DataResponseWithHistoriaFlag';

export const getChronologickyRegisterZakonovDetailObsahHtmlContent = async (
  year: string | undefined,
  number: string | undefined,
  ucinnost: string | undefined,
):
  Promise<ClientResponse<DataResponseWithHistoriaFlag>> => {
  const {
    data,
    status,
  } = await axios.get(
    `/static/SK/ZZ/${year}/${number}/${ucinnost}.obsah`,
  );
  return {
    data: { response: data, historia: false },
    responseCode: status,
  };
};
